import React, { useState } from 'react';
import { AmazonPayButton, bootstrapWithAmazon } from 'amazon-pay-react';
import ErrorLabel from '../../input/ErrorLabel';

export type AmazonPayCheckoutButtonProps = {
  clientId: string | null;
  sellerId: string | null;
  isSandbox: boolean;
  isLoaded: boolean;
  onAuthorize: (accessToken: string) => void;
  onLoaded: () => void;
};

const AmazonPayCheckoutButton: React.FC<AmazonPayCheckoutButtonProps> = ({
  clientId,
  sellerId,
  isSandbox,
  isLoaded,
  onAuthorize,
  onLoaded,
}: AmazonPayCheckoutButtonProps) => {
  const BootstrappedAmazonPayButton = bootstrapWithAmazon(AmazonPayButton);
  const [buttonError, setButtonError] = useState<string | undefined>(undefined);

  // TODO: Remove any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleAmazonAuthorization = async (response: any): Promise<void> => {
    setButtonError(undefined);
    if (response.status === 'complete' && response.access_token) {
      await onAuthorize(response.access_token);
    } else {
      setButtonError('Unable to create Amazon Pay transaction');
    }
  };

  const handleAmazonOnLoaded = (): void => {
    onLoaded();
  };

  return (
    <div
      className="flex"
      id="amazon-btn-container"
      style={{ maxWidth: '250px' }}
    >
      <BootstrappedAmazonPayButton
        clientId={clientId}
        sellerId={sellerId}
        scope="profile payments:widget payments:shipping_address payments:billing_address"
        type="PwA"
        color="Gold"
        size="large"
        useAmazonAddressBook
        onAuthorization={handleAmazonAuthorization}
        isSandbox={isSandbox}
        // TODO: Need to add multiple region support
        region="us"
        onAmazonReady={handleAmazonOnLoaded}
        amazonScriptLoaded={isLoaded}
      />
      <ErrorLabel className="text-center">{buttonError}</ErrorLabel>
    </div>
  );
};

export default AmazonPayCheckoutButton;
